var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"aside-menu"},[_vm._v("\n  ASide\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }